<template>
  <div class="manufacturer-management">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      top="68px"
      :modal="false"
      :show-close="false"
      class="manufacturer-dialog"
      @close="handleClose">
      
     <template slot="title">
       <div class="dialog-header">
         <span>{{ title || '厂家信息' }}</span> <!-- 使用props传入的title -->
         <div class="header-buttons">
           <el-button 
             type="text" 
             size="medium" 
             @click="handleClose" 
             icon="el-icon-close"
             title="关闭">
           </el-button>
         </div>
       </div>
     </template>
      
      <div class="form-container">
        <!-- 左侧表单 - 占60%宽度 -->
        <div class="form-left">
          <el-form :model="manufacturerForm" :rules="rules" ref="manufacturerForm" label-width="120px" size="mini">
            <!-- 基本信息部分 -->
            <div class="form-section">
              <h3 class="section-title">基本信息</h3>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="生产厂家" prop="prodentpId">
                    <el-select 
                      v-model="manufacturerForm.prodentpId" 
                      filterable
                      remote
                      :remote-method="searchNameMethod"
                      @focus="handlefoucsName" 
                      @change="handleNameChange" 
                      :popper-append-to-body="false"
                      :loading="loading"
                      style="width: 100%"
                      v-el-select-infinite-scroll="handleScrollToBottom"
                    >
					<el-group>
						<!-- 固定头部 -->
						<div class="select-header" slot="header">
						  <span class="header-item">厂家序号</span>
						  <span class="header-item">厂家名称</span>
						  <span class="header-item">厂家编码</span>
						  <span class="header-item">产地</span>
						</div>
						<el-option 
						  v-for="item in nameOptions" 
						  :key="item._uid" 
						  :label="item.label" 
						  :value="item.id"
						>
						  <div class="option-row">
							<span class="option-item">{{ item.id }}</span>
							<el-tooltip :content="item.manufacturerName" placement="top">
							  <span class="option-item">{{ item.manufacturerName }}</span>
							</el-tooltip>
							<span class="option-item">{{ item.coding }}</span>
							<span class="option-item">{{ item.origin || '---' }}</span>
						  </div>
						</el-option>
					</el-group>
                      
					  <!-- 无搜索结果时的提示 -->
						<div v-if="showNoManufacturerData && nameOptions.length === 0 && currentQuery" slot="empty" class="no-data-prompt">
						  <i class="el-icon-warning"></i>
						  <p>系统厂家表中暂无 '<span class="highlight-query">{{ currentQuery }}</span>' 的生产厂家数据</p>
						  <el-button type="text" class="quick-add-link" @click="openQuickAddManufacturerDialog">
							请点击手动添加
						  </el-button>
						</div>
											
                      <!-- 加载状态提示 -->
                      <div v-if="loading" slot="empty" class="load-more">
                        <i class="el-icon-loading"></i> 加载中...
                      </div>
                      <div v-else-if="scrollLoading" slot="empty" class="load-more">
                        <i class="el-icon-loading"></i> 加载更多...
                      </div>
                      <div v-else-if="!hasMore && nameOptions.length > 0" slot="empty" class="load-more">
                        没有更多数据了
                      </div>
                      <div v-else-if="nameOptions.length === 0" slot="empty" class="load-more">
                        暂无数据
                      </div>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="厂家编码" prop="coding">
                    <el-input v-model="manufacturerForm.coding"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产地" prop="orplc">
                    <el-input v-model="manufacturerForm.orplc"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自付比例" prop="ratio">
                    <el-input v-model="manufacturerForm.ratio">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中标次数" prop="bidCnt">
                    <el-input v-model="manufacturerForm.bidCnt"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="带量采购" prop="cntBuy">
                    <el-select v-model="manufacturerForm.cntBuy" style="width: 100%">
                      <el-option 
                        v-for="item in YNoptions" 
                        :key="item.value" 
                        :label="item.label" 
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="集采中选" prop="gatherBuyType">
                    <el-select v-model="manufacturerForm.gatherBuyType" style="width: 100%">
                      <el-option 
                        v-for="item in YNoptions" 
                        :key="item.value" 
                        :label="item.label" 
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="批准文号" prop="manuLotnum">
                    <el-input v-model="manufacturerForm.manuLotnum"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="网采编码" prop="netCode">
                    <el-input v-model="manufacturerForm.netCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-section">
              <h3 class="section-title">追溯信息</h3>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="小包装追溯标识码" prop="drugTracMinId">
                    <el-input 
                      v-model="manufacturerForm.drugTracMinId"
                      @input="handleTraceInput('drugTracMinId')"
                      placeholder="请输入7位数字追溯码"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="大包装追溯标识码" prop="drugTracMaxId">
                    <el-input 
                      v-model="manufacturerForm.drugTracMaxId"
                      @input="handleTraceInput('drugTracMaxId')"
                      placeholder="请输入7位数字追溯码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="追溯码换算数量" prop="drugTracMaxCnt">
                    <el-input-number 
                      v-model="manufacturerForm.drugTracMaxCnt"
                      :min="0"
                      :step="1"
                      controls-position="right"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="追溯码强制扫码" prop="drugTracB">
                    <el-checkbox 
                      v-model="manufacturerForm.drugTracB" 
                      :true-label="1" 
                      :false-label="0"
                    >{{ manufacturerForm.drugTracB ? '是' : '否' }}</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-section">
              <h3 class="section-title">其他信息</h3>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="注册型号" prop="regModel">
                    <el-input v-model="manufacturerForm.regModel"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="注册规格" prop="regSpc">
                    <el-input v-model="manufacturerForm.regSpc"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="ypId" prop="ypId">
                    <el-input v-model="manufacturerForm.ypId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="备注" prop="remark">
                    <el-input v-model="manufacturerForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>

        <!-- 右侧表单 - 占40%宽度 -->
          <div class="form-right">
            <!-- 有效期设置部分 -->
            <div class="form-section">
              <h3 class="section-title">有效期设置</h3>
              <el-form :model="manufacturerForm" label-width="100px" size="mini">
                <el-form-item label="有效天数" prop="expyDate">
                  <el-input v-model="manufacturerForm.expyDate" placeholder="请输入有效天数">
                    <template slot="append">天</template>
                  </el-input>
                  <div class="field-tip">药品的有效期天数，单位为天</div>
                </el-form-item>
                <el-form-item label="有效状态" prop="status">
                  <el-select v-model="manufacturerForm.status" style="width: 100%">
                    <el-option 
                      v-for="item in statusOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <div class="field-tip">标识厂家当前是否可用</div>
                </el-form-item>
              </el-form>
            </div>
        
            <!-- 医保信息部分 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">医保信息</h3>
                <el-button 
                  class="fetch-button"
                  type="primary" 
                  size="mini" 
                  :loading="insuranceLoading"
                  @click="fetchMedicalInsuranceInfo">
                  获取医保信息
                </el-button>
              </div>
              
              <!-- 加载状态 -->
              <div v-if="insuranceLoading" class="loading-overlay">
                <i class="el-icon-loading"></i>
                <span style="margin-left: 8px;">正在获取医保信息...</span>
              </div>
                            
              <el-form :model="manufacturerForm" :rules="rules" ref="insuranceForm" label-width="100px" size="mini">
                <el-form-item label="医保名称" prop="chsName">
                  <el-select 
                    v-model="manufacturerForm.chsName"
                    placeholder="请选择医保名称"
                    style="width: 100%"
                    :disabled="medicalInsuranceOptions.length === 0"
                    filterable>
                    <el-option 
                      v-for="item in medicalInsuranceOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <div class="field-tip">药品在医保系统中的标准名称</div>
                </el-form-item>
                
                <el-form-item label="医保编码" prop="chsCode">
                  <el-input 
                    v-model="manufacturerForm.chsCode" 
                    placeholder="医保编码将自动填充"
                    :disabled="true">
                  </el-input>
                  <div class="field-tip">药品在医保系统中的唯一编码</div>
                </el-form-item>
                
                <el-form-item label="药品本位码" prop="drugCode">
                  <el-input v-model="manufacturerForm.drugCode" placeholder="药品本位码"></el-input>
                  <div class="field-tip">药品本位码</div>
                </el-form-item>
              </el-form>
            </div>
        
            <div class="field-description">
              <h4>字段说明</h4>
              <ul>
                <li><strong>医保名称</strong>：药品在医保系统中的标准名称</li>
                <li><strong>医保编码</strong>：药品在医保系统中的唯一编码</li>
                <li><strong>药品本位码</strong>：药品的唯一标识码</li>
              </ul>
            </div>
          </div>
        </div>
	
	<span slot="footer" class="dialog-footer">
	  <el-button size="mini" type="primary" @click="handleSave">保存</el-button>
	  <el-button size="mini" @click="handleClose">取消</el-button>
	</span>
  </el-dialog>
  
  <!-- 快速添加生产厂家信息弹窗 -->
    <el-dialog title="快速添加生产厂家信息" :visible.sync="quickAddManufacturerDialogVisible" width="600px" 
      :close-on-click-modal="false" :append-to-body="true" class="quick-add-manufacturer-dialog"
      :before-close="handleQuickAddManufacturerClose">
      
      <el-form :model="quickAddManufacturerForm" :rules="quickAddManufacturerRules" ref="quickAddManufacturerForm" label-width="150px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="厂家名称：" prop="manufacturerName" required>
              <el-input v-model="quickAddManufacturerForm.manufacturerName" placeholder="请输入生产厂家名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拼音简码：" prop="pinyinCode">
              <el-input v-model="quickAddManufacturerForm.pinyinCode" placeholder="自动生成拼音简码" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人：" prop="contacts" required>
              <el-input v-model="quickAddManufacturerForm.contacts" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contactNumber" required>
              <el-input v-model="quickAddManufacturerForm.contactNumber" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="编码：" prop="coding">
              <el-input v-model="quickAddManufacturerForm.coding" placeholder="请输入编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产地：" prop="origin">
              <el-input v-model="quickAddManufacturerForm.origin" placeholder="请输入产地"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="creditCode">
              <el-input v-model="quickAddManufacturerForm.creditCode" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照：" prop="businessLicense">
              <el-input v-model="quickAddManufacturerForm.businessLicense" placeholder="请输入营业执照"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生产许可证：" prop="productionLicense">
              <el-input v-model="quickAddManufacturerForm.productionLicense" placeholder="请输入生产许可证"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产有效期：" prop="productionValidityPeriod">
              <el-date-picker
                v-model="quickAddManufacturerForm.productionValidityPeriod"
                type="date"
                placeholder="选择生产有效期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="卫生许可证：" prop="hygienicLicense">
              <el-input v-model="quickAddManufacturerForm.hygienicLicense" placeholder="请输入卫生许可证"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卫生有效期：" prop="hygieneValidityPeriod">
              <el-date-picker
                v-model="quickAddManufacturerForm.hygieneValidityPeriod"
                type="date"
                placeholder="选择卫生有效期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮箱：" prop="email">
              <el-input v-model="quickAddManufacturerForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="传真：" prop="fax">
              <el-input v-model="quickAddManufacturerForm.fax" placeholder="请输入传真"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮政编码：" prop="postalCode">
              <el-input v-model="quickAddManufacturerForm.postalCode" placeholder="请输入邮政编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="网址：" prop="url">
              <el-input v-model="quickAddManufacturerForm.url" placeholder="请输入网址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属地域：" prop="region">
              <el-input v-model="quickAddManufacturerForm.region" placeholder="请输入所属地域"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用对象：" prop="applicableObject">
              <el-input v-model="quickAddManufacturerForm.applicableObject" placeholder="请输入适用对象"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="有效期：" prop="periodValidity">
              <el-date-picker
                v-model="quickAddManufacturerForm.periodValidity"
                type="date"
                placeholder="选择有效期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用状态：" prop="status">
              <el-select v-model="quickAddManufacturerForm.status" style="width: 100%">
                <el-option label="可用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="备注：" prop="remake">
          <el-input
            v-model="quickAddManufacturerForm.remake"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleQuickAddManufacturerClose">取消</el-button>
        <el-button size="small" type="primary" @click="handleQuickAddManufacturerSubmit" 
          :loading="quickAddManufacturerLoading">确定添加</el-button>
      </span>
    </el-dialog>
</div>
</template>

<script>
// 导入接口
import { getManufacturer, getPariCode, getManufacturerById, addManufacturer } from "@/api/MedicenCata.js";
 
// 自定义指令：实现下拉框无限滚动
const elSelectInfiniteScroll = {
  bind(el, binding) {
    const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAPPER_DOM) {
      SELECTWRAPPER_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};
 
export default {
  name: 'ManFacter',
  directives: {
    'el-select-infinite-scroll': elSelectInfiniteScroll
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    manufacturerData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'add'
    },
    drugData: {
      type: Object,
      default: () => ({})
    },
    // 新增：自定义标题
    title: {
      type: String,
      default: '厂家信息'
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      insuranceLoading: false, // 医保信息加载状态
      scrollLoading: false,
      hasMore: true,
      nameOptions: [],
      currentQuery: '',
      pageNum: 1,
      pageSize: 48,
      isSearchMode: false,
      allSearchResults: [],
      displayedResults: [],
      displayBatchSize: 99,
      currentDisplayPage: 1,
      medicalInsuranceOptions: [],
      
      // 新增：无生产厂家数据提示
      showNoManufacturerData: false,
      
      // 新增：快速添加生产厂家相关
      quickAddManufacturerDialogVisible: false,
      quickAddManufacturerLoading: false,
      quickAddManufacturerForm: {
        applicableObject: "",
        businessLicense: "",
        coding: "",
        contactNumber: "",
        contacts: "",
        creditCode: "",
        email: "",
        fax: "",
        hygieneValidityPeriod: "",
        hygienicLicense: "",
        id: '',
        manufacturerName: "",
        origin: "",
        periodValidity: this.getCurrentDate(),
        pinyinCode: "",
        postalCode: "",
        productionLicense: "",
        productionValidityPeriod: this.getCurrentDate(),
        region: "",
        remake: "",
        status: 1,
        url: ""
      },
      
      quickAddManufacturerRules: {
        manufacturerName: [
          { required: true, message: '请输入厂家名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactNumber: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$|^(0\d{2,3}-?)?\d{7,8}$/, message: '请输入正确的手机号或固定电话', trigger: 'blur' }
        ]
      },
      
      manufacturerForm: {
        "expyDate": '',
        "barCode": "",
        "bidCnt": '',
        "bidLv": '',
        "chsBeginTime": "",
        "chsCode": "",
        "chsEndTime": "",
        "chsName": "",
        "clinicId": '',
        "createId": '',
        "createTime": "",
        "drugCode": "",
        "drugId": '',
        "coding": '',
        "gatherBuyType": '',
        "id": '',
        "localDrugs": '',
        "manuLotnum": "",
        "netCode": "",
        "orplc": "",
        "prodentpId": '',
        "ratio": "",
        "regBrand": "",
        "regModel": "",
        "regSpc": "",
        "remark": "",
        "spcId": "",
        "status": 1,
        "ypId": "",
        'drugTracMinId': "",
        'drugTracMaxId': "",
        'drugTracMaxCnt': "",
        'drugTracB': 0,
      },
      
      YNoptions: [
        {id: 0, label: '否', value: '否'},
        {id: 1, label: '是', value: '是'}
      ],
      
      statusOptions: [
        {id: 0, label: '禁用'},
        {id: 1, label: '可用'}
      ],
      
      rules: {
        prodentpId: [{ required: true, message: '此项必填', trigger: 'change' }],
        chsName: [
          { required: true, message: '医保名称为必填项', trigger: 'blur' }
        ],
        chsCode: [
          { required: true, message: '医保编码为必填项', trigger: 'blur' }
        ],
        drugTracMinId: [
          { pattern: /^\d*$/, message: '只能输入数字', trigger: 'blur' }
        ],
        drugTracMaxId: [
          { pattern: /^\d*$/, message: '只能输入数字', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          if (this.mode === 'edit' && this.manufacturerData) {
            // 编辑模式：使用传入的厂家数据并获取详细信息
            this.handleEditMode();
          } else {
            // 新增模式：重置表单
            this.resetForm();
          }
        }
      }
    },
    
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    },
    
    // 监听厂家名称变化，自动生成拼音码
    'quickAddManufacturerForm.manufacturerName': {
      handler(newVal) {
        if (newVal && newVal.trim()) {
          this.quickAddManufacturerForm.pinyinCode = this.getFirstLetter(newVal);
        } else {
          this.quickAddManufacturerForm.pinyinCode = '';
        }
      }
    }
  },
  methods: {
    // 处理编辑模式
    async handleEditMode() {
      try {
        this.loading = true;
        
        // 首先使用传入的数据填充表单
        this.manufacturerForm = { ...this.manufacturerData };
        
        // 如果有厂家ID，调用接口获取详细信息
        if (this.manufacturerData.prodentpId) {
          await this.loadManufacturerById(this.manufacturerData.prodentpId);
        } else if (this.manufacturerData.id) {
          // 如果prodentpId不存在，尝试使用id
          await this.loadManufacturerById(this.manufacturerData.id);
        } else {
          // 如果没有ID，直接使用传入的数据
          this.fillFormWithManufacturerData(this.manufacturerData);
        }
        
      } catch (error) {
        console.error('处理编辑模式失败:', error);
        this.$message.error('加载厂家信息失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 根据ID获取厂家详细信息
    async loadManufacturerById(manufacturerId) {
      try {
        const res = await getManufacturerById({
          id: manufacturerId // 使用id作为参数
        });
        
        if (res.code === 200 && res.data) {
          const manufacturer = res.data;
          
          // 更新厂家下拉框选项，确保选中项存在
          this.nameOptions = [{
            id: manufacturer.id,
            label: manufacturer.manufacturerName,
            manufacturerName: manufacturer.manufacturerName,
            coding: manufacturer.coding,
            origin: manufacturer.origin || manufacturer.orplc,
            _uid: Math.random().toString(36).substr(2, 9)
          }];
          
          // 使用接口返回的数据填充表单
          this.fillFormWithManufacturerData(manufacturer);
          
          this.$message.success('厂家信息已自动加载');
        } else {
          // 如果接口失败，使用传入的数据
          this.fillFormWithManufacturerData(this.manufacturerData);
          this.$message.warning('未找到对应的厂家详细信息，使用现有数据');
        }
      } catch (error) {
        console.error('根据ID获取厂家信息失败:', error);
        // 接口失败时使用传入的数据
        this.fillFormWithManufacturerData(this.manufacturerData);
        this.$message.error('获取厂家信息失败，使用现有数据');
      }
    },
    
    // 使用厂家数据填充表单
    fillFormWithManufacturerData(manufacturerData) {
      // 确保表单有正确的厂家ID
      this.manufacturerForm.prodentpId = manufacturerData.prodentpId || manufacturerData.id;
      
      // 填充其他字段
      this.manufacturerForm.manufacturerName = manufacturerData.manufacturerName;
      this.manufacturerForm.coding = manufacturerData.coding;
      this.manufacturerForm.orplc = manufacturerData.orplc || manufacturerData.origin;
      // 填充其他可能存在的字段
      if (manufacturerData.expyDate) this.manufacturerForm.expyDate = manufacturerData.expyDate;
      if (manufacturerData.ratio) this.manufacturerForm.ratio = manufacturerData.ratio;
      if (manufacturerData.bidCnt) this.manufacturerForm.bidCnt = manufacturerData.bidCnt;
      if (manufacturerData.manuLotnum) this.manufacturerForm.manuLotnum = manufacturerData.manuLotnum;
      if (manufacturerData.netCode) this.manufacturerForm.netCode = manufacturerData.netCode;
      if (manufacturerData.status !== undefined) this.manufacturerForm.status = Number(manufacturerData.status);
      if (manufacturerData.drugTracMinId) this.manufacturerForm.drugTracMinId = manufacturerData.drugTracMinId;
      if (manufacturerData.drugTracMaxId) this.manufacturerForm.drugTracMaxId = manufacturerData.drugTracMaxId;
      if (manufacturerData.drugTracMaxCnt) this.manufacturerForm.drugTracMaxCnt = manufacturerData.drugTracMaxCnt;
      if (manufacturerData.drugTracB !== undefined) this.manufacturerForm.drugTracB = manufacturerData.drugTracB;
      if (manufacturerData.chsName) this.manufacturerForm.chsName = manufacturerData.chsName;
      if (manufacturerData.chsCode) this.manufacturerForm.chsCode = manufacturerData.chsCode;
      if (manufacturerData.ypId) this.manufacturerForm.ypId = manufacturerData.ypId;
    },
    
    resetForm() {
      this.manufacturerForm = {
        "expyDate": '',
        "barCode": "",
        "bidCnt": '',
        "bidLv": '',
        "chsBeginTime": "",
        "chsCode": "",
        "chsEndTime": "",
        "chsName": "",
        "clinicId": '',
        "createId": '',
        "createTime": "",
        "drugCode": "",
        "drugId": '',
        "coding": '',
        "gatherBuyType": '',
        "id": '',
        "localDrugs": '',
        "manuLotnum": "",
        "netCode": "",
        "orplc": "",
        "prodentpId": '',
        "ratio": "",
        "regBrand": "",
        "regModel": "",
        "regSpc": "",
        "remark": "",
        "spcId": "",
        "status": 1,
        "ypId": "",
        'drugTracMinId': "",
        'drugTracMaxId': "",
        'drugTracMaxCnt': "",
        'drugTracB': 0,
      };
      this.nameOptions = [];
    },
    
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    
    // 在生产厂家子组件的handleSave方法中添加
    handleSave() {
      this.$refs.manufacturerForm.validate(async valid => {
        if (valid) {
          try {
            this.loading = true;
            
            // 确保保存的数据包含必要的字段
            const saveData = { 
              ...this.manufacturerForm,
              mode: this.mode // 将模式也传递给父组件
            };
    
            if (saveData) {
              this.$message.success('保存成功');
              
              // 触发保存事件，将数据传递给父组件
              this.$emit('save', saveData);
              
              // 关闭对话框
              this.handleClose();
            } else {
              this.$message.error('保存失败');
            }
          } catch (error) {
            console.error('保存失败:', error);
            this.$message.error('保存失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    
    // 获取医保信息
    async fetchMedicalInsuranceInfo() {
      // 获取必要的参数
      const drugName = this.drugData.drugName || this.drugData.label || '';
      const approvalNumber = this.manufacturerForm.manuLotnum || '';
      const manufacturerName = this.manufacturerForm.manufacturerName || '';
      
      // 验证必要字段
      if (!drugName) {
        this.$message.warning('请先选择药品名称');
        return;
      }
      
      if (!approvalNumber) {
        this.$message.warning('请填写批准文号');
        return;
      }
      
      if (!manufacturerName) {
        this.$message.warning('请选择生产厂家');
        return;
      }
      
      this.insuranceLoading = true;
      
      try {
        const res = await getPariCode({ 
          drugName: drugName,
          chsCode: '', // 不管为空
          approvalNumber: approvalNumber,
          prodentpName: manufacturerName
        });
        
        if (res.code === 200 && res.data) {
          // 处理医保信息数据
          this.medicalInsuranceOptions = res.data.map(item => ({
            id: item.id,
            label: item.registeredName || item.label,
            mcCode: item.mcCode || item.value
          }));
          
          // 默认选择第一项
          if (this.medicalInsuranceOptions.length > 0) {
            this.manufacturerForm.chsName = this.medicalInsuranceOptions[0].id;
            this.manufacturerForm.chsCode = this.medicalInsuranceOptions[0].mcCode;
          }
          
          this.$message.success('医保信息获取成功');
        } else {
          this.$message.error(res.message || '获取医保信息失败');
        }
      } catch (error) {
        console.error('获取医保信息出错:', error);
        this.$message.error('获取医保信息出错');
      } finally {
        this.insuranceLoading = false;
      }
    },
    
    handleMedicalInsuranceSelect(selectedId) {
      const selectedOption = this.medicalInsuranceOptions.find(option => option.id === selectedId);
      if (selectedOption) {
        this.manufacturerForm.chsCode = selectedOption.mcCode;
      }
    },
 
    // 滚动到底部时触发加载更多
    handleScrollToBottom() {
      if (this.hasMore && !this.scrollLoading) {
        this.loadMoreData();
      }
    },
    
    // 加载更多数据
    async loadMoreData() {
      if (this.isSearchMode) {
        // 搜索模式下的分页加载
        this.currentDisplayPage++;
        const start = (this.currentDisplayPage - 1) * this.displayBatchSize;
        const end = start + this.displayBatchSize;
        
        if (end >= this.allSearchResults.length) {
          this.hasMore = false;
          this.displayedResults = this.allSearchResults;
        } else {
          this.displayedResults = this.allSearchResults.slice(0, end);
        }
        
        this.nameOptions = this.displayedResults;
      } else {
        // 普通浏览模式的分页加载
        this.pageNum++;
        await this.loadManufacturerData(true);
      }
    },
    
    async loadManufacturerData(isLoadMore = false) {
      try {
        if (!isLoadMore) {
          this.loading = true;
          this.pageNum = 1; // 重置页码
        } else {
          this.scrollLoading = true;
        }
        
        const res = await getManufacturer({
          manufacturerName: this.currentQuery,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        
        if (res.code === 200) {
          const newData = res.data.content.map(v => ({ 
            label: v.manufacturerName, 
            ...v,
            _uid: Math.random().toString(36).substr(2, 9)
          }));
          
          if (this.isSearchMode) {
            // 搜索模式：保存所有结果
            if (!isLoadMore) {
              this.allSearchResults = newData;
              this.currentDisplayPage = 1;
              this.showNoManufacturerData = newData.length === 0;
            } else {
              this.allSearchResults = [...this.allSearchResults, ...newData];
              this.showNoManufacturerData = this.allSearchResults.length === 0;
            }
            
            // 显示当前批数据
            const start = (this.currentDisplayPage - 1) * this.displayBatchSize;
            const end = start + this.displayBatchSize;
            
            if (end >= this.allSearchResults.length) {
              this.hasMore = false;
              this.displayedResults = this.allSearchResults;
            } else {
              this.hasMore = true;
              this.displayedResults = this.allSearchResults.slice(0, end);
            }
            
            this.nameOptions = this.displayedResults;
          } else {
            // 普通浏览模式
            if (isLoadMore) {
              this.nameOptions = [...this.nameOptions, ...newData];
            } else {
              this.nameOptions = newData;
              this.showNoManufacturerData = newData.length === 0;
            }
            
            this.hasMore = res.data.content.length >= this.pageSize;
          }
        } else {
          // 接口返回错误
          this.showNoManufacturerData = true;
          this.nameOptions = [];
        }
      } catch (error) {
        console.error('获取厂家数据出错:', error);
        this.$message.error('获取厂家数据失败');
        this.showNoManufacturerData = true;
        this.nameOptions = [];
      } finally {
        this.loading = false;
        this.scrollLoading = false;
      }
    },
        
    searchNameMethod: _.debounce(function(query) {
      this.currentQuery = query.trim();
      this.pageNum = 1;
      this.isSearchMode = !!this.currentQuery;
      
      if (!this.currentQuery) {
        this.isSearchMode = false;
        this.allSearchResults = [];
        this.showNoManufacturerData = false;
      }
      
      // 重置状态
      this.allSearchResults = [];
      this.displayedResults = [];
      this.currentDisplayPage = 1;
      this.hasMore = true;
      
      this.loadManufacturerData();
    }, 500),
    
    handlefoucsName() {
      this.loadManufacturerData();
    },
    
    handleNameChange(val) {
      let result = this.nameOptions.find(item => item.id === val);
      if (result) {
        this.manufacturerForm.manufacturerName = result.manufacturerName;
        this.manufacturerForm.coding = result.coding;
        this.manufacturerForm.orplc = result.origin;
      }
    },
    
    handleTraceInput(field) {
      this.manufacturerForm[field] = this.manufacturerForm[field].replace(/\D/g, '');
      if (this.manufacturerForm[field] && this.manufacturerForm[field].length > 7) {
        this.manufacturerForm[field] = this.manufacturerForm[field].substring(0, 7);
      }
    },
    
    // 新增：打开快速添加生产厂家对话框
    openQuickAddManufacturerDialog() {
      console.log('打开快速添加生产厂家对话框，当前查询:', this.currentQuery);
      this.quickAddManufacturerDialogVisible = true;
      
      // 填充厂家名称
      this.quickAddManufacturerForm.manufacturerName = this.currentQuery || '';
      
      // 自动生成拼音码
      if (this.currentQuery) {
        this.quickAddManufacturerForm.pinyinCode = this.getFirstLetter(this.currentQuery);
      }
      
      // 设置默认有效期
      this.quickAddManufacturerForm.periodValidity = this.getCurrentDate();
      this.quickAddManufacturerForm.productionValidityPeriod = this.getCurrentDate();
    },
    
    // 处理快速添加生产厂家提交
    async handleQuickAddManufacturerSubmit() {
      try {
        const valid = await this.$refs.quickAddManufacturerForm.validate();
        if (!valid) return;
        
        this.quickAddManufacturerLoading = true;
        
        console.log('提交快速添加生产厂家数据:', this.quickAddManufacturerForm);
        
        const res = await addManufacturer(this.quickAddManufacturerForm);
        
        if (res.code === 200) {
          this.$message.success('生产厂家添加成功！');
          
          // 关闭快速添加对话框
          this.quickAddManufacturerDialogVisible = false;
          
          // 重置快速添加表单
          this.resetQuickAddManufacturerForm();
          
          // 将新添加的厂家添加到选项列表中
          const newManufacturer = {
            id: res.data.id || Date.now(),
            label: this.quickAddManufacturerForm.manufacturerName,
            manufacturerName: this.quickAddManufacturerForm.manufacturerName,
            coding: this.quickAddManufacturerForm.coding,
            origin: this.quickAddManufacturerForm.origin,
            _uid: Math.random().toString(36).substr(2, 9)
          };
          
          // 将新厂家添加到列表首位
          this.nameOptions.unshift(newManufacturer);
          
          // 自动选择新添加的厂家
          this.manufacturerForm.prodentpId = newManufacturer.id;
          this.handleNameChange(newManufacturer.id);
          
          // 确保下拉框显示新添加的厂家
          this.$nextTick(() => {
            this.$message.success(`已自动选择生产厂家: ${newManufacturer.manufacturerName}`);
          });
          
        } else {
          this.$message.error(res.message || '添加生产厂家失败');
        }
      } catch (error) {
        console.error('添加生产厂家失败:', error);
        this.$message.error('添加生产厂家失败');
      } finally {
        this.quickAddManufacturerLoading = false;
      }
    },
    
    // 新增：关闭快速添加生产厂家对话框
    handleQuickAddManufacturerClose() {
      this.quickAddManufacturerDialogVisible = false;
      this.resetQuickAddManufacturerForm();
    },
    
    // 新增：重置快速添加生产厂家表单
    resetQuickAddManufacturerForm() {
      this.quickAddManufacturerForm = {
        applicableObject: "",
        businessLicense: "",
        coding: "",
        contactNumber: "",
        contacts: "",
        creditCode: "",
        email: "",
        fax: "",
        hygieneValidityPeriod: "",
        hygienicLicense: "",
        id: 0,
        manufacturerName: "",
        origin: "",
        periodValidity: this.getCurrentDate(),
        pinyinCode: "",
        postalCode: "",
        productionLicense: "",
        productionValidityPeriod: this.getCurrentDate(),
        region: "",
        remake: "",
        status: 1,
        url: ""
      };
    },
    
    // 新增：获取当前日期
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 新增：获取拼音首字母
    getFirstLetter(str) {
      if (!str || typeof str !== 'string') return '';
      
      try {
        const chineseChars = str.match(/[\u4e00-\u9fa5]/g) || [];
        if (chineseChars.length === 0) return '';
        
        const initials = chineseChars.map(char => {
          const pinyinResult = pinyin(char, {
            toneType: 'none',
            type: 'array',
            multiple: false,
          })[0] || '';
          return pinyinResult.charAt(0).toUpperCase();
        });
        
        return initials.join('');
      } catch (error) {
        console.error('拼音转换失败:', error);
        return '';
      }
    }
  }
};
</script>
 
<style lang="less" scoped>
::v-deep .el-form-item__label{
  font-size: 12px;
  font-weight: bold;
}

.manufacturer-management {
  .manufacturer-dialog {
    .el-dialog {
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      max-width: 1000px;
    }
    
    .el-dialog__body {
      padding: 12px;
      overflow-y: auto;
    }
    
    .form-container {
      display: flex;
      gap: 12px;
    }
    
    .form-right {
      flex: 2;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    
    .form-section {
      margin-bottom: 12px;
      padding: 4px;
      border: 1px solid #e6e8eb;
      border-radius: 4px;
      background: #fff;
      position: relative;
      .section-title{
		padding: 4px;
      	border-left: 4px solid #409EFF;
      }
      /deep/ .el-select {
        width: 100%;
        
        .select-header {
          display: flex;
          justify-content: space-between;
          padding: 8px;
          background-color: #f1f1f1;
          font-size: 12px;
          font-weight: bold;
          position: sticky;
          top: 0;
          z-index: 10;
          
          .header-item {
            flex: 1;
            text-align: center;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        
        .el-select-dropdown__item {
          padding: 0;
          height: auto;
          
          .option-row {
            display: flex;
            justify-content: space-between;
            width: 100%;
            // padding: 8px;
            
            .option-item {
              flex: 1;
              text-align: center;
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
      			  border-top: 1px solid #ccc;
      			  border-right: 1px solid #ccc;
      			  border-bottom: 1px solid #ccc;
            }
          }
        }
        
        .load-more {
          text-align: center;
          padding: 8px;
          color: #909399;
          font-size: 12px;
        }
      }
    }
    .section-header{
    	display: flex;
		justify-content: space-between;
		align-items: center;
		.el-button{
			height: 28px;
		}
    }
    .loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10;
      border-radius: 4px;
    }
    
    .field-tip {
      font-size: 12px;
      color: #909399;
      margin-top: 4px;
      line-height: 1.4;
    }
    
    .field-description {
      padding: 15px;
      background-color: #f9f9f9;
      border-radius: 4px;
      border-left: 4px solid #409EFF;
      
      h4 {
        margin-bottom: 10px;
        color: #303133;
        font-size: 12px;
        font-weight: 600;
      }
      
      ul {
        padding-left: 20px;
        color: #606266;
      }
      
      li {
        margin-bottom: 12px;
        font-size: 12px;
        line-height: 1.5;
        
        strong {
          color: #409EFF;
        }
      }
    }
    
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      
      span {
        font-size: 16px;
		color: #000000;
        font-weight: bold;
      }
      
      .header-buttons {
        display: flex;
        align-items: center;
        
        /deep/ .el-button {
          padding: 0;
          margin-left: 8px;
          color: #409EFF;
          
          &:hover {
            color: #aa0000;
            background-color: transparent;
          }
        }
      }
    }
    
    .select-header {
      box-sizing: border-box;
    }
    
    .option-row {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 12px;
      
      span {
        padding: 0 4px;
      }
    }
    
    .load-more {
      text-align: center;
      padding: 8px;
      color: #909399;
      font-size: 12px;
    }
    
    .el-dialog__footer {
      padding: 15px 20px;
      border-top: 1px solid #eee;
      text-align: center;
      
      .el-button {
        min-width: 90px;
        border-radius: 4px;
      }
    }
  }
}
</style>